<div class="reports-dashboard-container">
  <div class="page-header">
    <h2 class="page-title">Reports Dashboard</h2>
    <button mat-raised-button class="back-button" (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
      Back
    </button>
  </div>

  <mat-tab-group class="dashboard-tabs" animationDuration="200ms" mat-stretch-tabs="false">
    <!-- Reports Tab -->
    <mat-tab label="Reports">
      <div class="tab-content">
        <div class="table-toolbar">
          <span class="table-title">Generated Reports</span>
        </div>

        <div *ngIf="isLoading" class="loading-row">
          <mat-spinner diameter="36"></mat-spinner>
          <span>Loading reports...</span>
        </div>

        <div *ngIf="loadError" class="error-row">
          <mat-icon>error_outline</mat-icon>
          <span>Failed to load reports. Please try again.</span>
        </div>

        <ng-container *ngIf="!isLoading && !loadError">
        <div class="table-wrapper">
          <table mat-table [dataSource]="reportsDataSource" matSort #reportsSort="matSort" class="reports-table">

            <!-- Report Type Column -->
            <ng-container matColumnDef="reportType">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Report Type
                <button mat-icon-button class="column-filter-btn"
                  [class.filter-active]="hasActiveFilter('reportType')"
                  (click)="openFilter('reportType', $event)" matTooltip="Filter">
                  <mat-icon class="filter-icon">filter_alt</mat-icon>
                </button>
              </th>
              <td mat-cell *matCellDef="let row">
                <span class="report-type-chip">{{ row.reportType }}</span>
              </td>
            </ng-container>

            <!-- File Name Column -->
            <ng-container matColumnDef="fileName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                File Name
                <button mat-icon-button class="column-filter-btn"
                  [class.filter-active]="hasActiveFilter('fileName')"
                  (click)="openFilter('fileName', $event)" matTooltip="Filter">
                  <mat-icon class="filter-icon">filter_alt</mat-icon>
                </button>
              </th>
              <td mat-cell *matCellDef="let row">{{ row.fileName }}</td>
            </ng-container>

            <!-- Generated Date Column -->
            <ng-container matColumnDef="generatedDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Generated Date
                <button mat-icon-button class="column-filter-btn"
                  [class.filter-active]="hasActiveFilter('generatedDate')"
                  (click)="openFilter('generatedDate', $event)" matTooltip="Filter">
                  <mat-icon class="filter-icon">filter_alt</mat-icon>
                </button>
              </th>
              <td mat-cell *matCellDef="let row">{{ row.generatedDate }}</td>
            </ng-container>

            <!-- Filters Column -->
            <ng-container matColumnDef="filters">
              <th mat-header-cell *matHeaderCellDef>Filters</th>
              <td mat-cell *matCellDef="let row">
                <button mat-icon-button class="filter-view-btn" (click)="viewFilters(row)" matTooltip="View applied filters">
                  <mat-icon class="filter-icon">filter_list</mat-icon>
                </button>
              </td>
            </ng-container>

            <!-- Status Column -->
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Status
                <button mat-icon-button class="column-filter-btn"
                  [class.filter-active]="hasActiveFilter('status')"
                  (click)="openFilter('status', $event)" matTooltip="Filter">
                  <mat-icon class="filter-icon">filter_alt</mat-icon>
                </button>
              </th>
              <td mat-cell *matCellDef="let row">
                <span class="status-indicator">
                  <span class="status-dot" [ngClass]="getStatusClass(row.status)"></span>
                  {{ row.status }}
                </span>
              </td>
            </ng-container>

            <!-- Expiry Date Column -->
            <ng-container matColumnDef="expiryDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Expiry Date</th>
              <td mat-cell *matCellDef="let row">{{ row.expiryDate }}</td>
            </ng-container>

            <!-- Download Column -->
            <ng-container matColumnDef="download">
              <th mat-header-cell *matHeaderCellDef>Download</th>
              <td mat-cell *matCellDef="let row">
                <span [matTooltip]="downloadTooltip(row.status, row.expiryDate)" style="display:inline-flex;">
                  <button mat-icon-button
                    [class.download-btn]="isDownloadable(row.status, row.expiryDate)"
                    [class.download-btn-disabled]="!isDownloadable(row.status, row.expiryDate)"
                    [disabled]="!isDownloadable(row.status, row.expiryDate)"
                    (click)="downloadReport(row)">
                    <mat-icon>download</mat-icon>
                  </button>
                </span>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="reportsDisplayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: reportsDisplayedColumns;"></tr>

            <tr class="mat-row no-data-row" *matNoDataRow>
              <td class="mat-cell no-data-cell" [attr.colspan]="reportsDisplayedColumns.length">
                No reports found.
              </td>
            </tr>
          </table>
        </div>

        <mat-paginator [pageSizeOptions]="[10, 25, 50]" pageSize="10" showFirstLastButtons></mat-paginator>
        </ng-container>
      </div>
    </mat-tab>

    <!-- Failed Reports Tab -->
    <mat-tab label="Failed Reports">
      <div class="tab-content">
        <div class="table-toolbar">
          <span class="table-title">Failed Reports</span>
        </div>

        <div class="table-wrapper">
          <table mat-table [dataSource]="failedFilesDataSource" matSort #failedSort="matSort" class="reports-table">

            <!-- Report Type Column -->
            <ng-container matColumnDef="reportType">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Report Type
                <button mat-icon-button class="column-filter-btn"
                  [class.filter-active]="hasActiveFilter('reportType')"
                  (click)="openFilter('reportType', $event)" matTooltip="Filter">
                  <mat-icon class="filter-icon">filter_alt</mat-icon>
                </button>
              </th>
              <td mat-cell *matCellDef="let row">
                <span class="report-type-chip">{{ row.reportType }}</span>
              </td>
            </ng-container>

            <!-- File Name Column -->
            <ng-container matColumnDef="fileName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                File Name
                <button mat-icon-button class="column-filter-btn"
                  [class.filter-active]="hasActiveFilter('fileName')"
                  (click)="openFilter('fileName', $event)" matTooltip="Filter">
                  <mat-icon class="filter-icon">filter_alt</mat-icon>
                </button>
              </th>
              <td mat-cell *matCellDef="let row">{{ row.fileName }}</td>
            </ng-container>

            <!-- Generated Date Column -->
            <ng-container matColumnDef="generatedDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Generated Date
                <button mat-icon-button class="column-filter-btn"
                  [class.filter-active]="hasActiveFilter('generatedDate')"
                  (click)="openFilter('generatedDate', $event)" matTooltip="Filter">
                  <mat-icon class="filter-icon">filter_alt</mat-icon>
                </button>
              </th>
              <td mat-cell *matCellDef="let row">{{ row.generatedDate }}</td>
            </ng-container>

            <!-- Filters Column -->
            <ng-container matColumnDef="filters">
              <th mat-header-cell *matHeaderCellDef>Filters</th>
              <td mat-cell *matCellDef="let row">
                <button mat-icon-button class="filter-view-btn" (click)="viewFilters(row)" matTooltip="View applied filters">
                  <mat-icon class="filter-icon">filter_list</mat-icon>
                </button>
              </td>
            </ng-container>

            <!-- Status Column -->
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
              <td mat-cell *matCellDef="let row">
                <span class="status-indicator">
                  <span class="status-dot" [ngClass]="getStatusClass(row.status)"></span>
                  {{ row.status }}
                </span>
              </td>
            </ng-container>

            <!-- Error Info Column -->
            <ng-container matColumnDef="errorInfo">
              <th mat-header-cell *matHeaderCellDef>Error Info</th>
              <td mat-cell *matCellDef="let row">
                <button mat-icon-button class="error-info-btn"
                  (click)="viewErrorInfo(row)"
                  matTooltip="View error details">
                  <mat-icon>info_outline</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="failedFilesDisplayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: failedFilesDisplayedColumns;"></tr>

            <tr class="mat-row no-data-row" *matNoDataRow>
              <td class="mat-cell no-data-cell" [attr.colspan]="failedFilesDisplayedColumns.length">
                No failed reports found.
              </td>
            </tr>
          </table>
        </div>

        <mat-paginator #failedPaginator [pageSizeOptions]="[10, 25, 50]" pageSize="10" showFirstLastButtons></mat-paginator>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>

<!-- Column filter dismiss overlay -->
<div *ngIf="activeFilterColumn" class="filter-input-overlay" (click)="closeActiveFilter()"></div>

<!-- Column filter input popup -->
<div *ngIf="activeFilterColumn" class="filter-input-popup"
  [style.left.px]="filterInputX"
  [style.top.px]="filterInputY">
  <mat-form-field appearance="outline" class="filter-input-field">
    <mat-label>Filter {{ activeFilterColumn }}</mat-label>
    <input matInput
      [value]="columnFilters[activeFilterColumn] || ''"
      (input)="onFilterInput(activeFilterColumn, $any($event.target).value)"
      (click)="$event.stopPropagation()"
      autofocus>
    <button matSuffix mat-icon-button *ngIf="columnFilters[activeFilterColumn]"
      (click)="clearColumnFilter(activeFilterColumn)" matTooltip="Clear filter">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
</div>

<!-- Filter Cards Popup -->
<div *ngIf="showFiltersPopup" class="screen-overlay" (click)="closeFiltersPopup()"></div>
<div *ngIf="showFiltersPopup" class="filter-list-selection-container">
  <div class="filter-list-card-container">
    <div class="filter-card" *ngFor="let f of filterCards">
      <mat-card appearance="raised"
        [ngClass]="f.isFiltered ? 'card-style filter-selected' : 'card-style'"
        [matTooltip]="f.value">
        <mat-card-content>
          <span class="filter-card-text-container">
            <mat-icon class="filter-card-check-icon">check</mat-icon>
            <span class="filter-card-text">{{ f.label }}: {{ f.value | slice:0:30 }}{{ f.value.length > 30 ? '...' : '' }}</span>
          </span>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <div style="padding-right:5px;padding-top:5px;">
    <mat-icon (click)="closeFiltersPopup()" style="cursor:pointer;padding-right:5px;padding-top:5px;" matTooltip="Close">close</mat-icon>
  </div>
</div>

<!-- Error Info Popup -->
<div *ngIf="showErrorInfoPopup" class="screen-overlay" (click)="closeErrorInfoPopup()"></div>
<div *ngIf="showErrorInfoPopup" class="error-info-popup">
  <div class="error-info-header">
    <span class="error-info-title">
      <mat-icon class="error-info-title-icon">error_outline</mat-icon>
      Error Details
    </span>
    <mat-icon (click)="closeErrorInfoPopup()" class="close-icon">close</mat-icon>
  </div>
  <div class="error-info-body">
    <pre class="error-info-text">{{ selectedErrorInfo }}</pre>
  </div>
</div>
